<template>
  <el-dialog
    :title="title"
    :visible="showDialog"
    width="50rem"
    :before-close="clearDialog"
    class="dialog"
    top="5vh"
    z-index="1000"
    :close-on-click-modal="false"
    append-to-body
  >
    <div class="section">
      <div class="section-content flex-center material-dialog">
        <el-form label-width="100px" style="width: 60%;" class="detail-form">
          <el-form-item label="品目编码：">
            <span>{{ materialInfo.materielCode || ' - ' }}</span>
          </el-form-item>
          <el-form-item label="品目名称：">
            <span>{{ materialInfo.materielName || ' - ' }}</span>
          </el-form-item>
          <el-form-item label="数量：">
            <span>{{
              materialInfo.materielNum
                ? strToThousands(materialInfo.materielNum)
                : ' - '
            }}</span>
          </el-form-item>
          <el-form-item label="参数型号：">
            <span>{{ materialInfo.materielModel || ' - ' }}</span>
          </el-form-item>
          <el-form-item v-if="!isSupplier" label="预算单价：">
            <span>{{
              materialInfo.budgetUnitPrice
                ? strToThousands(materialInfo.budgetUnitPrice)
                : ' - '
            }}</span>
            <money-in-cn :money="materialInfo.budgetUnitPrice" />
          </el-form-item>
          <el-form-item v-if="!isSupplier" label="总价：">
            <span>{{
              materialInfo.totalPrice
                ? strToThousands(materialInfo.totalPrice)
                : ' - '
            }}</span>
            <money-in-cn :money="materialInfo.totalPrice" />
          </el-form-item>
          <el-form-item label="品目单位：">
            <span>{{ materialInfo.unitType || ' - ' }}</span>
          </el-form-item>
          <el-form-item label="备注：">
            <span>{{ materialInfo.remarks || ' - ' }}</span>
          </el-form-item>
          <el-form-item label="附件上传：">
            <upload
              v-if="materialInfo.attachmentGroupId"
              :props-data="{
                groupIdBefore: materialInfo.attachmentGroupId,
                disabled: true
              }"
            />
            <span v-else>-</span>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button
        type="primary"
        :loading="loading"
        size="medium"
        @click="clearDialog"
      >
        确 定
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
// 组件
import Upload from '@/components/common/Upload/index'
import MoneyInCn from '@/components/common/MoneyInCn'
// 工具方法
import { strToThousands } from '@/utils/utils'

export default {
  name: 'MaterialDetailDialog',

  components: { Upload, MoneyInCn },

  model: {
    prop: 'showDialog',
    event: 'change'
  },

  props: {
    showDialog: {
      type: Boolean,
      required: true
    },

    title: {
      type: String,
      required: true
    },

    // 品目信息
    materialInfo: {
      type: Object,
      default: () => {}
    },

    // 上传组件需要的定义参数
    uploadParams: {
      type: Object,
      default: () => {
        return {
          bidType: '',
          attachmentType: ''
        }
      }
    },

    isSupplier: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      loading: false
    }
  },

  computed: {
    bizType() {
      return this.uploadParams.bizType
    },

    attachmentType() {
      return this.uploadParams.attachmentType
    }
  },

  methods: {
    strToThousands,

    // 关闭对话框时，执行的函数
    clearDialog() {
      this.$emit('change', !this.showDialog)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/variable.scss';

.material-dialog {
  span {
    display: inline-block;
    max-width: pixel-to-rem($n: 360);
  }

  //::v-deep .el-form {
  //  .el-form-item {
  //    margin-bottom: 0;
  //  }
  //}
}
</style>
